import { createRequest, handleErrorCatchLog } from 'Helpers/GenericHelpers'
import { getTokenFromSessionStorage } from 'Helpers/TokenHelper'
import { TypeOfChannel } from 'Slices/Omnichannel/DiscountSlice'
import dayjs, { Dayjs } from 'dayjs'

export interface IOmnichannelLogFilter {
  from?: Dayjs
  to?: Dayjs
  seasonIds: number[]
  typeOfChannel: TypeOfChannel
  name: string
  showSubRules: boolean
  operations?: number[]
}

export interface IOmnichannelLogItem {
  dateTime: string
  field: string
  ruleName: string
  oldValue: string
  newValue: string
  user: string
  typeOfLogStr: string
}

export async function getOmnichannelLogs(store, filter: IOmnichannelLogFilter): Promise<IOmnichannelLogItem[]> {
  const state = store.getState()
  const token = getTokenFromSessionStorage()
  if (!state.present.article.serverConfig || !token) {
    return []
  }

  const url = `/api/MpRules/OmnichannelLog?config=${state.present.article.serverConfig}`

  const body = { ...filter }

  try {
    const response = await createRequest(url, 'POST', body, token)
    const data = response.json()
    return data
  } catch (err) {
    handleErrorCatchLog(err, 'failed on retrieve logs from getOmnichannelLogs')
  }

  return []
}
